import axios from "@/api/axiosInstance";
import {
  DiagnosticCompaniesResult,
  ListDiagnosticCompaniesRequest,
  ListDiagnosticCompaniesResponse,
} from "./types";

/** Companies that already have at least one diagnostic on record. */
export const listDiagnosticCompanies = async (
  params: ListDiagnosticCompaniesRequest,
  signal?: AbortSignal,
): Promise<DiagnosticCompaniesResult> => {
  const response = await axios.get<ListDiagnosticCompaniesResponse>(
    "/api/private/diagnostics/companies",
    { params, signal },
  );
  return {
    companies: response.data.data.companies,
    // Falling back to the row count rather than to 0, as
    // `fetchCompanyDiagnostics` does: `totalCount` drives the pager, so a
    // missing envelope would report no records over a table full of them.
    totalCount:
      response.data.meta?.totalCount ?? response.data.data.companies.length,
  };
};
